import { useEffect, useState } from 'react';
import { createField, getFieldDetail, modifyField } from 'Api/endpoints/User';
import { useSelector } from 'react-redux';
import { isVietnam } from 'Util/DataUtils';
import { useDispatch } from 'react-redux';
import { convertISOformatOnlyDateUTC, getNowDate } from 'Util/DateUtils';
import { setAllFieldList, setDefaultField } from 'Actions/ConfigActions';
import { useError } from 'Api/hooks/useError';

// todo 리팩토링: useMemo, useCallback 적용, 의존성 추가

const initFieldData = () => ({
  name: '',
  constructStatus: '',
  address: '',
  address2: '',
  latitude: '',
  longitude: '',
  dateConstructStart: getNowDate(),
  dateConstructEnd: getNowDate(),
  spaceType: '',
  staffs: [],
  memo: '',
});

const useFieldAddUpdate = ({ open, fieldId, onClose }) => {
  const [fieldData, setFieldData] = useState(initFieldData());
  const { user } = useSelector(state => state.authUser);
  const { allFieldList } = useSelector(state => state.config);
  const dispatch = useDispatch();
  const { showErrorPopup } = useError();

  useEffect(() => {
    if (!open) return;
    if (fieldId) {
      fetchFieldDetail();
    } else {
      setFieldData(initFieldData());
    }
  }, [open]);

  const fetchFieldDetail = async () => {
    try {
      const result = await getFieldDetail(fieldId);
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message, onClose });
        return;
      }
      setFieldData({
        name: result.data.name || '',
        constructStatus: result.data.constructStatus || '',
        address: result.data.address || '',
        address2: result.data.address2 || '',
        latitude: result.data.location?.coordinates[1] || '',
        longitude: result.data.location?.coordinates[0] || '',
        dateConstructStart: result.data.dateConstructStart || null,
        dateConstructEnd: result.data.dateConstructEnd || null,
        spaceType: result.data.spaceType || '',
        staffs: result.data.staffs || [],
        memo: result.data.memo || '',
      });
    } catch (e) {
      console.log(e);
    }
  };

  const refreshStaffs = data => {
    setFieldData(prev => ({
      ...prev,
      staffs: data.staffs,
    }));
  };

  const onConfirm = async (setError, onClose) => {
    const { name, constructStatus, address, address2, latitude, longitude, dateConstructStart, dateConstructEnd, spaceType, memo } = fieldData;
    if (name === '') {
      setError('name');
      return;
    }
    if (constructStatus === '') {
      setError('constructStatus');
      return;
    }
    if (!isVietnam(user) && address === '') {
      setError('address');
      return;
    }
    if (!isVietnam(user) && address2 === '') {
      setError('address2');
      return;
    }
    const data = {
      field: {
        ...(fieldId && { fieldId }),
        name,
        ...(address && { address }),
        ...(address2 && { address2 }),
        ...(latitude && { latitude }),
        ...(longitude && { longitude }),
        constructStatus,
        ...(dateConstructStart && { dateConstructStart: convertISOformatOnlyDateUTC(dateConstructStart) }),
        ...(dateConstructEnd && { dateConstructEnd: convertISOformatOnlyDateUTC(dateConstructEnd) }),
        ...(spaceType && { spaceType }),
        active: true,
        ...(memo && { memo }),
      },
    };
    try {
      const result = fieldId ? await modifyField(data) : await createField(data);
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message });
        return;
      }
      const newField = result.data;
      let newAllFieldList = [];
      dispatch(setDefaultField(newField));
      if (!fieldId) {
        newAllFieldList = [newField, ...allFieldList.filter(x => x._id !== newField._id)];
      } else {
        newAllFieldList = allFieldList.map(x => {
          if (x._id === newField._id) {
            return newField;
          } else {
            return x;
          }
        });
      }
      dispatch(setAllFieldList(newAllFieldList));
      onClose();
    } catch (e) {
      console.log(e);
    }
  };

  const onChangeFieldData = (name, value) => {
    setFieldData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  return {
    fieldData,
    onChangeFieldData,
    onConfirm,
    refreshStaffs,
  };
};

export default useFieldAddUpdate;
